import {FiWifiOff} from "react-icons/fi";

export default function NetworkError({error}) {
    return <div className={"flex flex-col h-[90vh] items-center justify-center space-y-3 mt-8"}>
        <FiWifiOff className={"w-32 h-32 text-red-600"}/>
        <p className={"page-title text-3xl"}>{error.message}</p>
        {error?.response &&
            <p className={"text-xl uppercase font-semibold text-gray-800"}>{error?.response?.data?.message}</p>}
        <p className={"block mt-4 text-center"}> Something went wrong. Kindly contact management for
            assistance.</p>
    </div>;
}